import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page" dir="rtl">
      {/* هيدر الصفحة */}
      <div className="privacy-header text-center">
        <Container>
          <h1 className="display-4 fw-bold">سياسة الخصوصية</h1>
          <p className="lead">نحن نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية.</p>
        </Container>
      </div>

      <Container className="privacy-content my-5">
        <Row className="justify-content-center">
          <Col lg={10}>
            <section className="privacy-section">
              <h3>1. المعلومات التي نجمعها</h3>
              <p>
                نظراً لأن منصة "بيتي" لا تتطلب إنشاء حساب، فإننا لا نجمع بيانات شخصية بشكل تلقائي. المعلومات الوحيدة التي نحصل عليها هي التي تزودنا بها طواعية عند التواصل معنا عبر **واتساب** أو الهاتف، وتشمل:
              </p>
              <ul>
                <li>الاسم (إذا تم تزويدنا به).</li>
                <li>رقم الهاتف.</li>
                <li>تفاصيل العقار والصور (في حال كنت معلناً).</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h3>2. كيف نستخدم معلوماتك</h3>
              <p>نستخدم المعلومات التي تقدمها لنا للأغراض التالية فقط:</p>
              <ul>
                <li>نشر إعلانك العقاري على المنصة.</li>
                <li>تسهيل تواصل المشترين المحتملين معك مباشرة.</li>
                <li>الرد على استفساراتك وتقديم الدعم الفني.</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h3>3. مشاركة البيانات مع طرف ثالث</h3>
              <p>
                نحن لا نقوم ببيع أو تأجير بياناتك لأي جهات خارجية. تذكر أن معلومات الاتصال التي تضعها في "إعلانك" ستكون مرئية لزوار الموقع لتمكينهم من التواصل معك بشأن العقار.
              </p>
            </section>

            <section className="privacy-section">
              <h3>4. روابط الطرف الثالث</h3>
              <p>
                يحتوي موقعنا على روابط خارجية (مثل زر واتساب). نحن غير مسؤولين عن سياسات الخصوصية الخاصة بتلك التطبيقات أو المواقع الخارجية، وننصحك بمراجعة سياساتهم الخاصة.
              </p>
            </section>

            <section className="privacy-section">
              <h3>5. التعديلات على السياسة</h3>
              <p>
                قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سيتم نشر أي تغييرات على هذه الصفحة مع تحديث تاريخ "آخر تعديل".
              </p>
            </section>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;